// extracted by mini-css-extract-plugin
module.exports = {"primaryBtn":"PrimaryBtn_primaryBtn__rb6tr","outlineBtn":"PrimaryBtn_outlineBtn__E0pKZ","disabled":"PrimaryBtn_disabled__ImWmg"};